/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type PROJECT_STATUS = "DONE" | "HALTED" | "OPPORTUNITY" | "PLANNING" | "RUNNING" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AllPhasesDropdown_projects$ref: FragmentReference;
declare export opaque type AllPhasesDropdown_projects$fragmentType: AllPhasesDropdown_projects$ref;
export type AllPhasesDropdown_projects = $ReadOnlyArray<{|
  +node: ?{|
    +id: string,
    +name: ?string,
    +projectColor: ?string,
    +companyProjectId: ?number,
    +status: ?PROJECT_STATUS,
  |},
  +$refType: AllPhasesDropdown_projects$ref,
|}>;
export type AllPhasesDropdown_projects$data = AllPhasesDropdown_projects;
export type AllPhasesDropdown_projects$key = $ReadOnlyArray<{
  +$data?: AllPhasesDropdown_projects$data,
  +$fragmentRefs: AllPhasesDropdown_projects$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "AllPhasesDropdown_projects",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyProjectId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectTypeEdge"
};
// prettier-ignore
(node/*: any*/).hash = '06a49f920986d20a87a5fde27c7186a8';

module.exports = node;
